export default {
    AccountBalance: "Баланс",
    TurnoverSheet: "Оборотная ведомость",
    Transfers: "Отчет по первозкам",
    TransferUnitCount: "Отчет по грузовым единицам"
};
